import { render, staticRenderFns } from "./SituationCard.vue?vue&type=template&id=16c04d8c&scoped=true&"
import script from "./SituationCard.vue?vue&type=script&lang=js&"
export * from "./SituationCard.vue?vue&type=script&lang=js&"
import style0 from "./SituationCard.vue?vue&type=style&index=0&id=16c04d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c04d8c",
  null
  
)

export default component.exports